import React from 'react';
export function Footer() {
  return <footer className="bg-forest-900 px-4 pb-28 pt-10 text-center text-cream/70" data-id="element-195" data-mp="19ivlq3plplne">
      <p className="text-sm" data-id="element-196" data-mp="206ri3faq3orp">© 2026 · Elly Delgado · REFLEXOLOGY 21-DAY PRACTICE METHOD™ All Rights Reserved.</p>
      <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-cream/60" data-id="element-197" data-mp="2f4bjydcbp3tn">
        Educational material only. REFLEXOLOGY 21-DAY PRACTICE METHOD™ does not replace professional education, medical
        diagnosis, medical treatment, or healthcare advice.
      </p>
    </footer>;
}